module.exports = __webpack_public_path__ + "img/CIENTIFICA.be65a77a.jpg";